export default {
  title: 'Your review really helps ❤️',
  description: '{{name}} in the {{store}} — just tap a star',
  buttons: {
    not_now: 'Not now',
    continue: 'Continue',
  },
};
